import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { withTranslation } from '../common/translation';
import { getMenuList } from '../util';
import { MenuIcon } from '../common/icon';
import { BottomNavContainer } from '../../style/theme';
import { isLoggedIn } from '../../api/util';
import { EMPTY_STRING } from '../../constant/text';

const BottomNav = ({ t, sideNavOpen, setSideNavOpen }) => {
    const { pathname } = useLocation();
    const isActive = paths => paths.includes(pathname);

    return (
        <BottomNavContainer className="bottomNav">
            {isLoggedIn() && getMenuList().map(menuIcon => {
                const { icon: Icon, paths, toolTip } = menuIcon;
                return (
                    <Link
                        to={paths[0]}
                        key={paths[0]}
                        className="bottomNavItem"
                        onClick={() => setSideNavOpen(false)}
                    >
                        <Icon
                            toolTip={t(toolTip)}
                            className={`headerIcon menuIcon ${isActive(paths) && !sideNavOpen ? 'active' : EMPTY_STRING}`}
                        />
                    </Link>
                );
            })}
            <button
                type="button"
                className={`bottomNavItem bottomNavHamburger headerIcon menuIcon ${sideNavOpen ? 'active' : EMPTY_STRING}`}
                onClick={() => setSideNavOpen(prev => !prev)}
                aria-label="Menu"
            >
                <MenuIcon />
            </button>
        </BottomNavContainer>
    );
};

export default withTranslation()(BottomNav);
